/**
© BlockyApps. You are permitted to use this content within your store. Redistribution or use in any other application is strictly prohibited. 
Unauthorized copying, distribution, or reproduction in any form will result in legal action.
**/

if (!customElements.get("blocky-before-after-slider")) {
  customElements.define(
    "blocky-before-after-slider",
    class BlockyBeforeAfterSlider extends HTMLElement {
      constructor() {
        super();

        this.querySelector(".blocky-before-after-slider-input").addEventListener("input", (e) => {
          var sliderPos = e.currentTarget.value;
          var parentElement = e.currentTarget.parentElement;
          if (!parentElement) return;
          var afterImage = parentElement.querySelector(".blocky-before-after-after-image");
          var sliderLine = parentElement.querySelector(".blocky-before-after-slider-line");

          if (sliderLine) sliderLine.style.left = sliderPos + "%";
          if (!afterImage) return;
          afterImage.style.width = `${100 - sliderPos}%`;

          var media = afterImage.querySelector("img") || afterImage.querySelector("svg");
          if (media) media.style.transform = `translate(-${sliderPos}%,0)`;
        });
      }
    }
  );
}
